import type { GetTelemetryOptions } from '@moniebook-web/utils';

export const MICRO_FRONTENDS: GetTelemetryOptions['mfeManifest'] = [
    {
        name: 'orders-ui',
        bucketPath: '/orders-ui/assets',
        serviceName: 'moniebook-web-orders-ui',
        versionKeyOnWindowObject: '__ORDERS_UI_VERSION__',
    },
    {
        name: 'reports-ui',
        bucketPath: '/reports-ui/assets',
        serviceName: 'moniebook-web-reports-ui',
        versionKeyOnWindowObject: '__REPORTS_UI_VERSION__',
    },
    {
        name: 'registers-ui',
        bucketPath: '/registers-ui/assets',
        serviceName: 'moniebook-web-registers-ui',
        versionKeyOnWindowObject: '__REGISTERS_UI_VERSION__',
    },
    {
        name: 'sale-settings-ui',
        bucketPath: '/sale-settings-ui/assets',
        serviceName: 'moniebook-web-sale-settings-ui',
        versionKeyOnWindowObject: '__SALE_SETTINGS_UI_VERSION__',
    },
    {
        name: 'products-ui',
        bucketPath: '/products-ui/assets',
        serviceName: 'moniebook-web-products-ui',
        versionKeyOnWindowObject: '__PRODUCTS_UI_VERSION__',
    },
    {
        name: 'onboarding-ui',
        bucketPath: '/onboarding-ui/assets',
        serviceName: 'moniebook-web-onboarding-ui',
        versionKeyOnWindowObject: '__ONBOARDING_UI_VERSION__',
    },
    {
        name: 'customers-ui',
        bucketPath: '/customers-ui/assets',
        serviceName: 'moniebook-web-customers-ui',
        versionKeyOnWindowObject: '__CUSTOMERS_UI_VERSION__',
    },
    {
        name: 'inventory-onboarding-ui',
        bucketPath: '/inventory-onboarding-ui/assets',
        serviceName: 'moniebook-web-inventory-onboarding-ui',
        versionKeyOnWindowObject: '__INVENTORY_ONBOARDING_UI_VERSION__',
    },
    {
        name: 'accounting-ui',
        bucketPath: '/accounting-ui/assets',
        serviceName: 'moniebook-web-accounting-ui',
        versionKeyOnWindowObject: '__ACCOUNTING_UI_VERSION__',
    },
    {
        name: 'auth-ui',
        bucketPath: '/auth-ui/assets',
        serviceName: 'moniebook-web-auth-ui',
        versionKeyOnWindowObject: '__AUTH_UI_VERSION__',
    },
    {
        name: 'business-mgt-ui',
        bucketPath: '/business-mgt-ui/assets',
        serviceName: 'moniebook-web-business-mgt-ui',
        versionKeyOnWindowObject: '__BUSINESS_MGT_UI_VERSION__',
    },
    {
        name: 'dashboard-ui',
        bucketPath: '/dashboard-ui/assets',
        serviceName: 'moniebook-web-dashboard-ui',
        versionKeyOnWindowObject: '__DASHBOARD_UI_VERSION__',
    },
    {
        name: 'settings-ui',
        bucketPath: '/settings-ui/assets',
        serviceName: 'moniebook-web-settings-ui',
        versionKeyOnWindowObject: '__SETTINGS_UI_VERSION__',
    },
    {
        name: 'orders-ui-v2',
        bucketPath: '/orders-ui-v2/assets',
        serviceName: 'moniebook-web-orders-ui',
        versionKeyOnWindowObject: '__ORDERS_UI_VERSION__',
    },
    {
        name: 'reports-ui-v2',
        bucketPath: '/reports-ui-v2/assets',
        serviceName: 'moniebook-web-reports-ui',
        versionKeyOnWindowObject: '__REPORTS_UI_VERSION__',
    },
    {
        name: 'registers-ui-v2',
        bucketPath: '/registers-ui-v2/assets',
        serviceName: 'moniebook-web-registers-ui',
        versionKeyOnWindowObject: '__REGISTERS_UI_VERSION__',
    },
    {
        name: 'sale-settings-ui-v2',
        bucketPath: '/sale-settings-ui-v2/assets',
        serviceName: 'moniebook-web-sale-settings-ui',
        versionKeyOnWindowObject: '__SALE_SETTINGS_UI_VERSION__',
    },
    {
        name: 'products-ui-v2',
        bucketPath: '/products-ui-v2/assets',
        serviceName: 'moniebook-web-products-ui',
        versionKeyOnWindowObject: '__PRODUCTS_UI_VERSION__',
    },
    {
        name: 'onboarding-ui-v2',
        bucketPath: '/onboarding-ui-v2/assets',
        serviceName: 'moniebook-web-onboarding-ui',
        versionKeyOnWindowObject: '__ONBOARDING_UI_VERSION__',
    },
    {
        name: 'customers-ui-v2',
        bucketPath: '/customers-ui-v2/assets',
        serviceName: 'moniebook-web-customers-ui',
        versionKeyOnWindowObject: '__CUSTOMERS_UI_VERSION__',
    },
    {
        name: 'inventory-onboarding-ui-v2',
        bucketPath: '/inventory-onboarding-ui/assets',
        serviceName: 'moniebook-web-inventory-onboarding-ui',
        versionKeyOnWindowObject: '__INVENTORY_ONBOARDING_UI_VERSION__',
    },
    {
        name: 'accounting-ui-v2',
        bucketPath: '/accounting-ui-v2/assets',
        serviceName: 'moniebook-web-accounting-ui',
        versionKeyOnWindowObject: '__ACCOUNTING_UI_VERSION__',
    },
];
